import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=2d1e5014&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=2d1e5014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e5014",
  null
  
)

export default component.exports
import {QSeparator,QLinearProgress} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSeparator,QLinearProgress})
